<template>
    <div class="about-initiative-form9">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Assinale os documentos que sua iniciativa possui (marque todas que se aplicam)"
                label-for="documents"
                class="required"
            >
                <b-form-checkbox-group
                    id="documents"
                    name="documents"
                    v-model="$v.form.documents.selected.$model"
                    :options="form.documents.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('documents')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['doc_iniciativa_possui'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['doc_iniciativa_possui'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.others"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.documents.selected.includes(18)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('documents')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Em quais leis de incentivo sua iniciativa tem projetos aprovados?"
                label-for="laws"
                class="required"
                v-if="form.documents.selected.includes(13)"
            >
                <b-form-checkbox-group
                    id="laws"
                    name="laws"
                    v-model="$v.form.laws.selected.$model"
                    :options="form.laws.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('laws')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['leis_incentivo'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['leis_incentivo'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.lawsOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.laws.selected.includes(11)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('laws')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="
                        $router.push({
                            name:
                                getProfileId === 1
                                    ? 'AboutInitiativeForm8'
                                    : getProfileId === 2 && initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : getProfileId === 2 && !initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm5'
                                    : getProfileId === 3 && initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : getProfileId === 3 &&
                                      !initiative.interesse_em_ppp.includes(11) &&
                                      getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : getProfileId === 3 &&
                                      !initiative.interesse_em_ppp.includes(11) &&
                                      getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : 'AboutInitiativeForm12'
                        })
                    "
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button
                        :variant="'secondary'"
                        @click="
                            changeRegisterForm(
                                getProfileId === 1
                                    ? 'AboutInitiativeForm8'
                                    : getProfileId === 2 && initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : getProfileId === 2 && !initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm5'
                                    : getProfileId === 3 && initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : getProfileId === 3 &&
                                      !initiative.interesse_em_ppp.includes(11) &&
                                      getFirstInformation.id_natureza_inicitiva === 6
                                    ? 'AboutInitiativeForm13'
                                    : getProfileId === 3 &&
                                      !initiative.interesse_em_ppp.includes(11) &&
                                      getFirstInformation.id_natureza_inicitiva === 7
                                    ? 'AboutInitiativeForm14'
                                    : 'AboutInitiativeForm12'
                            )
                        "
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="
                            changeRegisterForm(getProfileId === 1 ? 'AboutInitiativeForm10' : 'AboutInitiativeForm11')
                        "
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { required } from 'vuelidate/lib/validators'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()
const registerFirstInformationApi = new RegisterFirstInformationApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        receiveFirstData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 47.09,
            message: null,
            authorizationData: null,
            isUpdate: false,
            firstInformationData: null,
            form: {
                documents: {
                    selected: [],
                    options: [
                        { text: 'Ata de Eleição da Atual Diretoria', item: 1, value: 1 },
                        { text: 'Ata de Fundação da organização e última atualização', item: 2, value: 2 },
                        { text: 'Auditoria externa', item: 3, value: 3 },
                        { text: 'Balanço Patrimonial do último exercício social', item: 4, value: 4 },
                        {
                            text:
                                'Certidão Conjunta de Débitos relativos aos Tributos Federais, Certidões negativa de débito trabalhista (CNDT) e regularidade com o FGTS',
                            item: 5,
                            value: 5
                        },
                        {
                            text: 'Certidão de isenção do Imposto de Transmissão Causa Mortis e Doação (ITCMD)',
                            item: 6,
                            value: 6
                        },
                        {
                            text:
                                'Certidões negativas de débitos fiscais (CND) nos âmbitos federal, estadual e municipal',
                            item: 7,
                            value: 7
                        },
                        { text: 'Comprovante de inscrição no CNPJ', item: 8, value: 8 },
                        {
                            text: 'Cópia do CPF/RG dos atuais representantes legais/sócios',
                            item: 9,
                            value: 9
                        },
                        { text: 'Demonstração do Resultado do Exercício – DRE', item: 10, value: 10 },
                        {
                            text:
                                'Documentação sobre parcerias (quando couber), tais como cartas de intenção, termos e/ou contratos de parceria. Essa documentação deve demonstrar a natureza da parceria (financeira, técnica, de recursos humanos, materiais e outros) e ser assinada pelos responsáveis legais de cada uma das entidades envolvidas',
                            item: 11,
                            value: 11
                        },
                        { text: 'Estatuto', item: 12, value: 12 },
                        { text: 'Projetos aprovados em leis de incentivo', item: 13, value: 13 },
                        { text: 'Orçamento Físico-Financeiro', item: 14, value: 14 },
                        {
                            text:
                                'Registro no respectivo Conselho Municipal dos Direitos da Criança e do Adolescente (exceto para aquelas organizações de Educação para o trabalho que atuem exclusivamente com jovens acima de 18 anos)',
                            item: 15,
                            value: 15
                        },
                        {
                            text: 'Resumo com o currículo (histórico de atuação) do responsável pelo projeto',
                            item: 16,
                            value: 16
                        },
                        { text: 'Nenhum', item: 17, value: 17 },
                        { text: 'Outros (especifique)', item: 18, value: 18 }
                    ]
                },
                others: null,
                laws: {
                    selected: [],
                    options: [
                        { text: 'Lei Rouanet', item: 1, value: 1 },
                        { text: 'Lei do Audiovisual', item: 2, value: 2 },
                        { text: 'Programa de Ação Cultural', item: 3, value: 3 },
                        { text: 'Lei de Incentivo ao Esporte', item: 4, value: 4 },
                        { text: 'PRONON - Programa Nacional de Oncologia', item: 5, value: 5 },
                        { text: 'PRONAS - Programa Nacional de Acessibilidade', item: 6, value: 6 },
                        { text: 'Fundo dos direitos da criança e do adolescente (FIA)', item: 7, value: 7 },
                        { text: 'Fundo Municipal do Idoso', item: 8, value: 8 },
                        { text: 'PROAC', item: 9, value: 9 },
                        { text: 'PROMAC', item: 10, value: 10 },
                        { text: 'Nenhum', item: 12, value: 12 },
                        { text: 'Outros (especifique)', item: 11, value: 11 }
                    ]
                },
                lawsOthers: null
            }
        }
    },
    validations: {
        form: {
            documents: {
                selected: { required }
            },
            laws: {
                selected: {
                    required() {
                        return !(this.form.laws.selected.length === 0 && this.form.documents.selected.includes(13))
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.documents.selected =
                data.doc_iniciativa_possui === null
                    ? []
                    : data.doc_iniciativa_possui.filter(item => typeof item === 'number')

            this.form.others =
                data.doc_iniciativa_possui === null
                    ? null
                    : data.doc_iniciativa_possui.filter(item => typeof item !== 'number')[0].others

            this.form.laws.selected =
                data.leis_incentivo === null ? [] : data.leis_incentivo.filter(item => typeof item === 'number')

            this.form.lawsOthers =
                data.leis_incentivo === null
                    ? null
                    : data.leis_incentivo.filter(item => typeof item !== 'number')[0].lawsOthers

            this.firstInformationData = this.receiveFirstData
            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative(), registerFirstInformationApi.listFirst()])
                .then(response => {
                    const data = response[0].data.data
                    this.firstInformationData = response[1].data

                    if (data !== null) {
                        this.initiative = data

                        this.form.documents.selected =
                            data.doc_iniciativa_possui === null
                                ? []
                                : data.doc_iniciativa_possui.filter(item => typeof item === 'number')

                        this.form.others =
                            data.doc_iniciativa_possui === null
                                ? null
                                : data.doc_iniciativa_possui.filter(item => typeof item !== 'number')[0].others

                        this.form.laws.selected =
                            data.leis_incentivo === null
                                ? []
                                : data.leis_incentivo.filter(item => typeof item === 'number')

                        this.form.lawsOthers =
                            data.leis_incentivo === null
                                ? null
                                : data.leis_incentivo.filter(item => typeof item !== 'number')[0].lawsOthers
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                doc_iniciativa_possui: this.form.documents.selected,
                leis_incentivo: this.form.laws.selected,
                percentual: currentProgress
            }

            data.doc_iniciativa_possui = [...data.doc_iniciativa_possui, { others: this.form.others }]
            data.leis_incentivo = [...data.leis_incentivo, { lawsOthers: this.form.lawsOthers }]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({
                            name: this.getProfileId === 1 ? 'AboutInitiativeForm10' : 'AboutInitiativeForm11'
                        })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.documents.options = this.form.documents.options.filter(x =>
                    this.form.documents.selected.includes(x.value)
                )

                this.form.laws.options = this.form.laws.options.filter(x =>
                    this.form.laws.selected.includes(x.value)
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getFirstInformation() {
            return this.firstInformationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm9-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm9.vue